declare global {
    interface Window {
        appName: string;
        appVersion: string;
        appPublicUrl: string;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        pendo: any;
    }
}
export const appName = window.appName;
export const baseName = window.appPublicUrl;
export const pendo = window.pendo;
